import { Container, Row, Col, Hidden } from '@leroy-merlin-br/backyard-react-ui'
import { LeroyLogo } from '@leroy-merlin-br/backyard-react-icons'

import * as S from './styled'

const Header = () => (
  <S.Header>
    <Container>
      <Row>
        <Col
          size={{
            giga: 3,
            tera: 2
          }}
        >
          <S.Brand>
            <a href="/">
              <LeroyLogo />
            </a>
          </S.Brand>
        </Col>
        <Col
          size={{
            giga: 9,
            tera: 10
          }}
        >
          <S.Nav>
            <S.NavBG />
          </S.Nav>
          <Hidden untilKilo kilo mega>
            <S.Meta>
              <S.SubHeading color="green" noMargin>
                Televendas:{' '}
              </S.SubHeading>
              <S.SubHeading noMargin>
                4007-1380 (Capitais) 0800-602-1380 (Demais regiões). Das 8h às
                19h de segunda a sábado
              </S.SubHeading>
            </S.Meta>
          </Hidden>
        </Col>
      </Row>
    </Container>
  </S.Header>
)

export default Header
